<div *ngIf="screenWidth > 1024" class="video-container w-100 h-100 position-absolute index-extralarge video-player-disable" 
    [ngClass]="{'video-player-active':videoActive}" 
    #videoplayer>
    <div class="video-player video-large">
        <iframe
            width="1425" height="559"
            loading="lazy"
            class="e2e-iframe-trusted-src index-negative"
            *ngIf="videoUrl"
            [src]="videoUrl"
            frameborder=0
            allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allow="autoplay; fullscreen">
        </iframe>
        <div class="exit-video-player desktop-div"></div>
        <!-- <div *ngIf="videoUrl" class="video-button-controller">     
            <a class="button  button-large" (click)="play()" *ngIf="player" 
                [ngClass]="{'d-none':player.clickPause, 
                'hidde-button': hiddeButton,
                'button-white': returnbuttoncolorvalue == 'white',
                'button-black' : returnbuttoncolorvalue == 'black'
                }">Play</a>

            <a class="button  button-large"  (click)="pause()"  *ngIf="player" 
                [ngClass]="{'d-none':player.clickPlay, 
                'hidde-button': hiddeButton,
                'button-white': returnbuttoncolorvalue == 'white',
                'button-black' : returnbuttoncolorvalue == 'black'}">Pause</a>
                
            <a class="button button-large"  (click)="replay()" *ngIf="player"
                [ngClass]="{'d-none':player.clickReplay,
                'hidde-button': hiddeButton,
                'button-white': returnbuttoncolorvalue == 'white',
                'button-black' : returnbuttoncolorvalue == 'black'}">Replay</a> 
        </div>  -->
        <div  *ngIf="videoUrl" class="bottom-video-item">
            <div class="timer-counter" *ngIf="player" [ngClass]="{'show-duration':durationTimer}">
                <div class="float-left d-flex" 
                    [ngClass]="{'f-white': returnbuttoncolorvalue == 'white',
                    'f-dark': returnbuttoncolorvalue == 'black'}" 
                    *ngIf="player.minuteprogress"> 
                        {{player.minuteprogress}} : {{player.secondprogress}} 
                </div> 
                <div class="float-left d-flex space-side-3" 
                    [ngClass]="{'f-white': returnbuttoncolorvalue == 'white',
                    'f-dark': returnbuttoncolorvalue == 'black'}" 
                    *ngIf="player.minuteprogress">/
                </div>
                <div class="d-flex" 
                [ngClass]="{'f-white': returnbuttoncolorvalue == 'white',
                'f-dark': returnbuttoncolorvalue == 'black'}" 
                *ngIf="player.totalminuteduration">{{player.totalminuteduration}} : {{player.totalsecondduration}} </div>
            </div>
            <div  class="seek-bar" *ngIf="player">
                <div class="slider" (click)="seekOutside($event)">
                <div class="slider-item"  [ngStyle]="{'width': player.seekbarproggress +'%'}"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="single-item-content-wrapper"
    [ngClass]="{
        'banner-left text-left':contentAlign == 'left',
        'banner-right text-right':contentAlign == 'right',
        'banner-center text-center':contentAlign == 'center'
    }">
        <div class="content-wrapper">
            <h3 class="heading3 animate-content" 
            [ngClass]="{'animate-content-active':videoPaused,
                      'f-white':textColor == 'white',
                      'f-darker':textColor == 'black'}">{{subtitle}}</h3>
            <h1 class="heading1 font-bold animate-content" 
            [ngClass]="{'animate-content-active':videoPaused,
                        'f-white':textColor == 'white',
                        'f-darker':textColor == 'black'}">{{title}}</h1>
        </div> 
    </div>
</div>

<div *ngIf="screenWidth <= 1024 && screenWidth > 768" class="video-wrapper bg-center bg-cover bg-no-repeat H-100-full" [ngClass]="{'active':playVideoMobile}"
    [ngStyle]="{'background': 'url(' + randomImage + ')'}" (click)="exitVideoMobile()">
    <div class="responsive-video-container" #videoplayermobile>
        <iframe [ngClass]="{'active':playVideoMobile}"
            width="1030"
            height="580"
            class="e2e-iframe-trusted-src" 
            *ngIf="videoUrlMobile" 
            [src]="videoUrlMobile"
            frameborder=0   
            allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allow="autoplay; fullscreen">
        </iframe>
    </div>
</div>
<div *ngIf="screenWidth <= 768" class="video-wrapper bg-center bg-cover bg-no-repeat H-100-full" [ngClass]="{'active':playVideoMobile}"
    [ngStyle]="{'background': 'url(' + randomImage + ')'}" (click)="exitVideoMobile()">
    <div class="responsive-video-container" #videoplayermobile>
        <iframe [ngClass]="{'active':playVideoMobile}"
            width="500"
            height="281"
            class="e2e-iframe-trusted-src" 
            *ngIf="videoUrlMobile" 
            [src]="videoUrlMobile"
            frameborder=0   
            allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allow="autoplay; fullscreen">
        </iframe>
    </div>
</div>